import { useSearchParams } from 'react-router-dom'

/**
 * `replace` swaps the current history entry instead of pushing a new one. Callers
 * that update a parameter as the user types want it, so that leaving the page
 * does not take one Back press per keystroke. It defaults to pushing, which is
 * what every caller did before the option existed.
 */
type ChangeSearchParamOptions = { replace?: boolean }

export const useChangeSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeSearchParam = (newSearchParamConfig?, { replace = false }: ChangeSearchParamOptions = {}) => {
    if (!newSearchParamConfig) {
      setSearchParams({}, { replace })
    } else {
      const { key, value, customSearchParams } = newSearchParamConfig
      const query = value ? { [key]: value } : {}
      const { [key]: _, ...lastQueries } = customSearchParams || Object.fromEntries(searchParams)

      setSearchParams({ ...lastQueries, ...query }, { replace })
    }
  }

  return { onChangeSearchParam, searchParams, setSearchParams }
}
